import { render, staticRenderFns } from "./InformationRequestForm.vue?vue&type=template&id=124cdddd&"
import script from "./InformationRequestForm.vue?vue&type=script&lang=js&"
export * from "./InformationRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports